module.exports = __webpack_public_path__ + "static/img/logo.c3ee24bd.png";